import React from 'react'

import formatCurrency from '../../utils/format-currency'

type Props = {
  value: number
}

const cents_including_separator = /(?=\.|,[0-9]{2}\$)/

export default function Amount(props: Props) {
  const [dollars, cents] = formatCurrency(props.value).split(
    cents_including_separator,
  )

  return (
    <span>
      <span data-testid="amount" className="dollars">
        {dollars}
      </span>
      <span className="cents">{cents}</span>
    </span>
  )
}
